(function () {
  "use strict";

  ManagePermissionsSidebarCtrl.$inject = ['$scope', 'groupsResource', 'usersResource'];
  angular
    .module('trainerWebApp.controllers')
    .controller('ManagePermissionsSidebarCtrl', ManagePermissionsSidebarCtrl);

  function ManagePermissionsSidebarCtrl($scope, groupsResource, usersResource) {
    $scope.allGroupsAccessType = "AllGroups";
    $scope.selectedGroupsAccessType = "SelectedGroups";
    $scope.createGroupText = "Create new group: ";

    var addGroupAction = "Add";
    var removeGroupAction = "Remove";
    var changeAccessTypeAction = "ChangeAccessType";

    var changes = [];

    var selectedUser = $scope.selectedUser;
    var restrictedGroups = _.map($scope.selectedUser.restrictedGroups || [], function (g) {
      return {
        id: g.groupId,
        text: g.groupName,
        userCount: g.userCount
      };
    });
    var allUserGroups = _.map($scope.allUserGroups, function (g) {
      return {
        id: g.id,
        text: g.name,
        userCount: g.userCount
      };
    });

    $scope.viewModel = {
      selectedGroups: restrictedGroups,
      roleName: selectedUser.roleName,
      groupAccessType: restrictedGroups.length == 0 ? $scope.allGroupsAccessType : $scope.selectedGroupsAccessType,
      serverCallInProgress: false,
      isDirty: false
    };

    $scope.selectOptions = {
      width: '100%',
      placeholder: "Add groups that this " + selectedUser.roleName + " has access to",
      multiple: true,
      query: query,
      /*data:$scope.allUserGroups,*/
      minimumInputLength: 0,
      maximumInputLength: 40,
      allowClear: true,
      dropdownCssClass: "select2-dropdown-size-hack"
    };

    function query(query) {
      var data = {results: getAllResults(query.term, query.element)};
      query.callback(data);
    }

    function getAllResults(term, elem) {

      var result = [];

      if (term && term.length > 0) {
        var termLower = term.toLowerCase();

        var exists = _.find(allUserGroups, function (item) {
          return item.text.toLowerCase() == termLower;
        });

        result = _.filter(allUserGroups, function (item) {
          return item.text.toLowerCase().indexOf(termLower) >= 0;
        });

        if ($.trim(term) && !exists) {
          var newItem = {id: -1, text: $scope.createGroupText + '"' + term + '"', value: $.trim(term)};
          if (elem.select2("container").hasClass('select2-drop-above')) {
            result.splice(0, 0, newItem);
          } else {
            result.push(newItem);
          }
        }

      } else {
        result = allUserGroups;
      }

      var selectedGroupIds = _.pluck($scope.viewModel.selectedGroups, "id");

      result = _.filter(result, function (item) {
        return !_.contains(selectedGroupIds, item.id);
      });

      return result;
    }

    $scope.addNewGroup = function (groupName, cb) {
      var newGroup = {name: groupName};
      $scope.viewModel.serverCallInProgress = true;
      groupsResource.addGroups([newGroup], function (res) {
        $scope.addNewGroupToSearch({id: res.groups[0].id, name: res.groups[0].name});
        $scope.viewModel.selectedGroups.push({
          id: res.groups[0].id,
          text: res.groups[0].name,
          userCount: 0
        });
        addSelectGroupChangeAction(res.groups[0].id);
        $scope.viewModel.serverCallInProgress = false;
        cb();
      }, function (err) {
        $scope.viewModel.serverCallInProgress = false;
        cb();
      });
    };

    $scope.selectGroup = function (groupId) {
      var group = _.find(allUserGroups, function (g) {
        return g.id == groupId;
      });

      $scope.viewModel.selectedGroups.push({
        id: group.id,
        text: group.text,
        userCount: group.userCount
      });

      addSelectGroupChangeAction(group.id);
    };

    function addSelectGroupChangeAction(groupId) {
      var action = _.find(changes, function (item) {
        return item.value == groupId;
      });

      if (action) {
        changes = _.filter(changes, function (item) {
          return item.value != groupId;
        });
      } else {
        changes.push({
          action: addGroupAction,
          value: groupId
        });
      }

      setIsDirty();
    }

    $scope.removeGroup = function (groupId) {
      $scope.viewModel.selectedGroups = _.filter($scope.viewModel.selectedGroups, function (g) {
        return g.id != groupId;
      });

      addRemoveGroupChangeAction(groupId);
    };

    function addRemoveGroupChangeAction(groupId) {
      var action = _.find(changes, function (item) {
        return item.value == groupId;
      });

      if (action) {
        changes = _.filter(changes, function (item) {
          return item.value != groupId;
        });
      } else {
        changes.push({
          action: removeGroupAction,
          value: groupId
        });
      }

      setIsDirty();
    }


    $scope.groupAccessTypeChange = function (accessType) {
      var action = _.find(changes, function (item) {
        return item.action == changeAccessTypeAction;
      });

      if (action) {
        changes = _.filter(changes, function (item) {
          return item.action != changeAccessTypeAction;
        });
      } else {
        changes.push({
          action: changeAccessTypeAction,
          value: accessType
        });
      }

      setIsDirty();
    };

    function setIsDirty() {
      $scope.viewModel.isDirty = changes.length > 0;
    }

    $scope.showGroupsSection = function () {
      return $scope.viewModel.groupAccessType == $scope.selectedGroupsAccessType;
    };

    $scope.cancelChanges = function () {
      $scope.changeSidebar('pages/users/userDetailsSidebar.html');
    };

    function clear() {
      $scope.viewModel.serverCallInProgress = false;
      $scope.viewModel.isDirty = false;
    }

    $scope.applyChanges = function () {
      if (!$scope.viewModel.isDirty) {
        return;
      }

      $scope.viewModel.serverCallInProgress = true;

      var groupIds = $scope.viewModel.groupAccessType == $scope.selectedGroupsAccessType
        ? _.pluck($scope.viewModel.selectedGroups, 'id')
        : [];

      usersResource.updateUserGroupsRestrictions(selectedUser.id, groupIds, function (res) {
        $scope.viewModel.serverCallInProgress = false;
        $scope.viewModel.isDirty = false;
        $scope.changeSidebar('pages/users/userDetailsSidebar.html');
      });
    };

    $scope.$on("$destroy", function () {
      clear();
    })
  }

})();
